import { useTranslation } from 'react-i18next';

import { ErrorState } from 'components/ErrorState/ErrorState';

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <ErrorState
      variant="notFound"
      title={t('sections.errorState.page.title')}
      description={t('sections.errorState.description')}
      action={{ label: t('sections.errorState.page.cta'), to: '/' }}
    />
  );
};
